import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import ProblemSection from "@/components/site/ProblemSection";
import FeaturesSection from "@/components/site/FeaturesSection";
import HowItWorks from "@/components/site/HowItWorks";
import AppShowcase from "@/components/site/AppShowcase";
import DownloadSection from "@/components/site/DownloadSection";
import WhyFarmers from "@/components/site/WhyFarmers";
import TrustStrip from "@/components/site/TrustStrip";
import CTASection from "@/components/site/CTASection";
import FAQSection from "@/components/site/FAQSection";
import Footer from "@/components/site/Footer";
import GolfClubStrip from "@/components/site/GolfClubStrip";
import ScrollProgress from "@/components/site/ScrollProgress";
import MobileQuickNav from "@/components/site/MobileQuickNav";
import useVisitTracker from "@/hooks/useVisitTracker";

export default function Landing() {
  useVisitTracker("/");
  return (
    <main data-testid="landing-page" className="bg-[#F9F8F6]">
      <ScrollProgress />
      <Nav />
      <Hero />
      <ProblemSection />
      <FeaturesSection />
      <HowItWorks />
      <AppShowcase />
      <DownloadSection />
      <WhyFarmers />
      <GolfClubStrip />
      <TrustStrip />
      <CTASection />
      <FAQSection />
      <Footer />
      <MobileQuickNav />
    </main>
  );
}
